import { render, staticRenderFns } from "./AffiliatesCode.vue?vue&type=template&id=7e77fa12&scoped=true"
import script from "./AffiliatesCode.vue?vue&type=script&lang=js"
export * from "./AffiliatesCode.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesCode.vue?vue&type=style&index=0&id=7e77fa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e77fa12",
  null
  
)

export default component.exports